

exports.__esModule = true;
exports.$unresolved = exports.$util = exports.isUnsafeRedirect = undefined;
exports.$getRedirectUrl = $getRedirectUrl;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;

var _event = require('./event');

var _logger = require('xo-beaver/dist/logger');

var _base = require('base64/base64.min');

var base64 = _interopRequireWildcard(_base);

var _config = require('./config');

var _integration = require('./integration');

var _angular = require('angular');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var redirected = false;
var paramCache = {};

// incase base64 has been CJS packed, it will export itself
if (typeof window.atob === 'undefined' || typeof window.btoa === 'undefined') {
    window.atob = base64.atob;
    window.btoa = base64.btoa;
}

var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
    return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {

    forEach: function forEach(collection, method) {
        if (collection instanceof Array) {
            for (var i = 0; i < collection.length; i++) {
                method(collection[i], i);
            }
        } else if (collection instanceof Object) {
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    method(collection[key], key);
                }
            }
        }
    },

    idleTimeout: function idleTimeout(time) {
        setTimeout(function () {
            _logger.$logger.info('page_idle');
            $util.reload();
        }, time);
    },


    reload: function reload() {
        _logger.$logger.info('reload');
        _event.$event.emit('loading');
        location.reload();
    },

    /**
     * replace: 
     * Insert URL params provided and reload the window
     * This does not find the param if it already exists in the URL. It will add it again
     * @param params {Object} param - Params to add as URL params
     */
    replace: function replace(params) {
        if (params) {
            // Note: This won't replace the 
            var url = $util.buildURL(location.href.split('#')[0], params);

            url = '' + url + window.location.hash;

            _logger.$logger.info('replace', { url: url });
            _event.$event.emit('loading');
            location.replace(url);
        } else {
            $util.reload();
        }
    },

    redirect: function redirect(url, options) {

        // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
        var frameBust = options && options.frameBust;

        if (isUnsafeRedirect(url)) {
            // eslint-disable-line
            _logger.$logger.error('unsafe_redirect_url', {
                url: url
            });
            throw new Error('Unsafe redirect url: ' + url);
        }

        _logger.$logger.info('redirect', {
            url: url
        });

        _event.$event.on('$stateChangeStart', function (event) {
            _logger.$logger.info('state_change_after_redirect');
            event.preventDefault();
        });

        function redir() {

            if (redirected) {
                return;
            }

            _logger.$logger.info('redirect', {
                url: url
            });

            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
                window.top.location = url;
            } else {
                window.location = url;
            }

            redirected = true;
        }

        _event.$event.emit('loading');

        _logger.$logger.flush().then(redir);
        setTimeout(redir, 500);

        _logger.$logger.done();
    },

    cookiesEnabled: function cookiesEnabled() {
        var cookiesEnabled = void 0;

        document.cookie = '_cookiecheck=1';
        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        return cookiesEnabled;
    },

    storageEnabled: function storageEnabled(api) {
        try {
            window[api].setItem('__feature_test__', '0');
            window[api].removeItem('__feature_test__');
            return true;
        } catch (e) {
            return false;
        }
    },

    sessionStorageEnabled: function sessionStorageEnabled() {
        return this.storageEnabled('sessionStorage');
    },

    localStorageEnabled: function localStorageEnabled() {
        return this.storageEnabled('localStorage');
    },

    params: function params(string) {

        if (typeof string !== 'string') {
            string = this.queryString().slice(1);
        }

        var params = {};

        if (!string) {
            return params;
        }

        if (paramCache[string]) {
            return $util.extend({}, paramCache[string]);
        }

        $util.forEach(string.split('&'), function (pair) {
            pair = pair.split('=');

            if (pair[0]) {
                params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
            }
        });

        paramCache[string] = params;

        return params;
    },

    queryString: function queryString() {
        if (window.location.search) {
            return window.location.search;
        } else {
            var string = window.location.href;
            var idx = string.indexOf('&');
            var rIdx = string.lastIndexOf('#');

            if (idx) {
                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
            }
        }
        return '';
    },

    queryStringSplice: function queryStringSplice(qs, insert, remove) {
        if (qs.indexOf('?') === 0) {
            qs = qs.slice(1);
        }

        var params = $util.extend(this.params(qs), insert);

        $util.forEach(remove, function (key) {
            delete params[key];
        });

        return '?' + this.paramToQueryString(params);
    },

    extend: function extend(obj, source) {

        if (!source) {
            return obj;
        }

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                obj[key] = source[key];
            }
        }

        return obj;
    },


    paramToQueryString: function paramToQueryString(params) {
        return this.filter(this.map(Object.keys(params).sort(), function (key) {
            if (!params[key]) {
                return;
            }

            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })).join('&');
    },

    param: function $param(name) {
        return this.params()[name];
    },

    hashParam: function hashParam(name) {
        return this.params(window.location.hash.slice(1))[name];
    },

    base64Decode: function base64Decode(encodedString) {
        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    base64Encode: function base64Encode(decodedString) {
        return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
    },

    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
        }
    },

    assert: function $assert(value, message, payload) {
        if (!value) {
            throw new Error(message, payload || {});
        }
    },

    map: function $map(array, method) {

        array = array || [];

        var results = void 0;

        if (array instanceof Array) {
            results = [];

            $util.forEach(array, function () {
                results.push(method.apply(this, arguments));
            });

            return results;
        } else if (array instanceof Object) {

            results = {};

            $util.forEach(array, function (val, key) {
                results[key] = method.apply(this, arguments);
            });

            return results;
        } else {
            throw new Error('$util.map expects array or object');
        }
    },

    filter: function $filter(array, method) {
        method = method || Boolean;
        var results = [];

        $util.forEach(array, function (item) {
            if (method.apply(this, arguments)) {
                results.push(item);
            }
        });

        return results;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#find()
     * If you have an object, use the lodash or underscore .find() method
     *
     * @deprecated
     */
    find: function $find(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
        }

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return array[i];
            }
        }
    },

    findIndex: function $find(array, method) {

        if (!array) {
            return;
        }

        for (var i = 0; i < array.length; i++) {
            if (method(array[i])) {
                return i;
            }
        }
    },

    range: function range(start, end) {
        if (!end) {
            end = start;
            start = 0;
        }

        var result = [];

        for (var i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    },

    pad: function $pad(string, n, char) {

        n = n || 0;
        char = char || '0';

        var padding = Array(n + 1).join(char.toString());

        return (padding + string).slice(-n);
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
     * the return value of $util.some() isn't always a Boolean. It's return value
     * is whatever the passed callback returns. If you are using $util.some to
     * find an object in an array then you need to use $util.find instead of Array#some().
     * Ex:
     *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
     *          preferredCard will be the preferred card object or undefined if there isn't a
     *          preferred card.
     *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
     *          Taking the code from #1 and simply swapping out $util.some for Array#some()
     *          will result in a different return value, in this case the Boolean true if
     *          there is a preferred card, otherwise false. In this case, instead of using
     *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
     *          as seen below:
     *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
     *
     * If you have an object, use the lodash or underscore .some() method
     *
     * @deprecated
     */
    some: function $some(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.');
        }

        var result = void 0;

        $util.forEach(array, function (item, key) {
            if (!result) {
                result = method(item, key);
            }
        });

        return result;
    },

    /**
     * Deprecated.
     *
     * If you have an array, use Array#every()
     * If you have an object, use the lodash or underscore .every() method
     *
     * @deprecated
     */
    every: function $every(array, method) {
        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
            _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
        }

        method = method || Boolean;

        var result = true;

        $util.forEach(array, function (item) {
            if (!method(item)) {
                result = false;
            }
        });

        return result;
    },

    reduce: function $reduce(array, method, intial) {
        $util.forEach(array, function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            intial = method.apply(undefined, [intial].concat(args));
        });

        return intial;
    },

    isPopup: function isPopup() {
        return _integration.$integration.isPopup();
    },

    isIFrame: function isIFrame() {
        return _integration.$integration.isIFrame();
    },

    buildURL: function buildURL(url, params) {
        /*
         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
         */
        this.assert(url, 'buildURL :: expected url');

        var paramKeys = Object.keys(params || {});

        if (JSON.stringify(params) === '{}') {
            return url;
        }

        if (!paramKeys.length) {
            return url;
        }

        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }

        url += this.paramToQueryString(params);

        return url;
    },

    paypalURL: function paypalURL(url, params) {
        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;

        return this.buildURL(url, params);
    },

    override: function override(obj, methodName, handler) {
        var existing = obj[methodName];

        obj[methodName] = function () {
            if (existing) {
                try {
                    existing.apply(obj, arguments);
                } catch (err) {
                    _logger.$logger.error(methodName + 'event_error', {
                        error: err.toString
                    });
                }
            }

            return handler.apply(obj, arguments);
        };
    },

    result: function result(method) {
        return method();
    },

    memoize: function memoize(method) {
        var result = void 0;
        var called = false;

        function memoized() {
            if (!called) {
                result = method.apply(this, arguments);
            }
            called = true;
            return result;
        }

        memoized.flush = function () {
            called = false;
        };

        return memoized;
    },

    now: function now() {
        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
    },

    bindObject: function bindObject(obj, self) {
        return $util.map(obj, function (method) {
            return method.bind(self);
        });
    },

    hashStr: function hashStr(str) {
        var hash = 0;
        var i = void 0;
        var chr = void 0;
        var len = void 0;

        if (str.length === 0) {
            return hash;
        }
        for (i = 0, len = str.length; i < len; i++) {
            chr = str.charCodeAt(i);
            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
            // Convert to 32bit integer
            hash |= 0; // eslint-disable-line no-bitwise
        }
        return Math.abs(hash);
    },

    hash: function hash() {
        return this.hashStr(Math.random());
    },

    popup: function popup(name, url, options, callback) {

        callback = $util.once(callback);

        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
            return key + '=' + options[key];
        }).join(', '));

        var interval = void 0;

        function checkWindowClosed() {
            if (win.closed) {
                clearInterval(interval);
                callback();
            }
        }

        interval = setInterval(checkWindowClosed, 50);
        setTimeout(checkWindowClosed);

        try {
            var close = win.close;

            win.close = function () {
                close.apply(this, arguments);
                checkWindowClosed();
            };
        } catch (err) {
            // pass
        }

        return win;
    },

    unique: function unique(collection) {
        return collection.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    },

    monkeyPatch: function monkeyPatch(mod, prop, method) {
        var original = mod[prop];

        mod[prop] = function () {
            var _this = this,
                _arguments = arguments;

            return method.call(this, arguments, function (self, args) {
                if (original) {
                    return original.apply(self || _this, args || _arguments);
                }
            });
        };
    },
    once: function once(method) {
        var called = false;

        return function () {
            if (!called) {
                called = true;
                return method.apply(this, arguments);
            }
        };
    },
    camelToDasherize: function camelToDasherize(string) {
        return string.replace(/([A-Z])/g, function (g) {
            return '-' + g.toLowerCase();
        });
    },
    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '_' + g[1];
        }).toUpperCase();
    },
    dasherizeToCamel: function dasherizeToCamel(string) {
        return string.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
    },


    parentWindow: function parentWindow() {
        if (window.opener) {
            return window.opener;
        } else if (window.parent !== window) {
            return window.parent;
        }
    },

    hasRTL: function hasRTL(str) {
        return new RegExp('[\u0590-\u07BF]').test(str);
    },
    noop: function noop() {// eslint-disable-line no-empty-function

    },


    /**
     * @function isObject - tests to see if a passed argument is an Object. Returns `false`
     *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
     *      as well as for `null` and `Object.create(null)`
     * @param {*} o
     * @returns {boolean}
     */
    isObject: function isObject(o) {
        var oAsString = Object.prototype.toString.call(o);

        return o instanceof Object && oAsString === '[object Object]';
    },


    /**
     * @function debounce
     * @param {function} callback
     * @param {number} time
     * @returns {function}
     */
    debounce: function debounce(callback, time) {
        var timeout = void 0;

        return function () {
            var _this2 = this;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var functionCall = function functionCall() {
                return callback.apply(_this2, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(functionCall, time);
        };
    },


    /**
     * @function getProperty
     * @param {object} obj
     * @param {string} propString
     * @param {string} splitOn
     * @returns {*}
     *
     * Ex:
     *  const obj = {
     *      a: {
     *          b: {
     *              c: 'property c'
     *          },
     *          'key.with.periods': 10
     *      }
     *  };
     *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
     *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
     *  const fDefault = $util.getProperty(
     *      obj,
     *      'a.b.c.d.e.f',
     *      { default: 'default value for f' }
     *  ); // f === 'default value for f'
     *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
     */
    getProperty: function getProperty(obj) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _options$splitOn = options.splitOn,
            splitOn = _options$splitOn === undefined ? '.' : _options$splitOn,
            defaultValue = options['default'];


        if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
            return;
        }

        var pathArray = path.split(splitOn);
        var prop = obj[pathArray.shift()];

        while (prop && pathArray.length && this.isObject(prop)) {
            prop = prop[pathArray.shift()];
        }

        return pathArray.length || prop === undefined ? defaultValue : prop;
    }
};

var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };

function $getRedirectUrl(product, params) {
    var url = '';
    var urlParams = $util.params();

    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
    }

    url += _config.$config.urls.fallbackUrl[product];

    $util.extend(urlParams, params || {});

    // cmd is a reserved slingshot param
    if (urlParams.cmd) {
        delete urlParams.cmd;
    }

    return $util.buildURL(url, urlParams);
}

function $dispatch(product, params, stateChange) {
    $util.assert(product, 'expected product');

    _logger.$logger.log('info', 'dispatch', {
        product: product
    });

    _event.$event.emit('loading');

    var url = '';

    url = $getRedirectUrl(product, params);

    // fire an event for xo-tracking to listen to and do fpti logging
    if (stateChange) {
        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
    }

    return $util.redirect(url);
}

function $experiment(name, sample, id, loggerPayload) {

    var throttle = $util.hashStr(name + '_' + id) % 100;

    var group = void 0;

    if ($util.param(name) === 'true') {
        group = 'test_forced';
    } else if ($util.param(name) === 'false') {
        group = 'control_forced';
    } else if (throttle < sample) {
        group = 'test';
    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
        // eslint-disable-line no-extra-parens
        group = 'control';
    } else {
        group = 'throttle';
    }

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: name,
        pxp_trtmnt_id: group
    });

    _logger.$logger.info(name + '_' + group, loggerPayload || {});

    if (group === 'test' || group === 'test_forced') {
        return true;
    } else if (group === 'control') {
        return false;
    }
}

angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;

_logger.$logger;

_config.$config;

_config.$meta;

_integration.$integration;

_angular.$log;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/core/util.js
// module id = ./components/squid/dist/core/util.js
// module chunks = 1